module.exports = __webpack_public_path__ + "static/media/icon-avis.3ba885a2.svg";